import { render, staticRenderFns } from "./Droparea.vue?vue&type=template&id=38e7ecf4&scoped=true"
import script from "./Droparea.vue?vue&type=script&lang=js"
export * from "./Droparea.vue?vue&type=script&lang=js"
import style0 from "./Droparea.vue?vue&type=style&index=0&id=38e7ecf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e7ecf4",
  null
  
)

export default component.exports